/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/no-inferrable-types */

/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */

export class MemoryPhaseConstants {
	public static maxGridScore: number = 10;
	public static halfGridScore: number = 5;
}
